import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnameStatus extends BaseModelAPI {
	static entity = 'stockopnamestatus';
	static entityName = 'stockopnamestatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.sequence = 0;
			this.remarks = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}